<template>
    <div class="warn-line-box" :class="{ isBlueColor: isBlueColor }" :style="dialongStyle">
        <div class="warn-line-box-top">
            <div>
                {{
                    sceneInfo && sceneInfo.obj === '视频测面积'
                        ? '识别污染物'
                        : sceneInfo.obj === '视频测流速'
                        ? '速度识别'
                        : '拦截方案'
                }}
            </div>
            <div class="el-icon-close" @click="$emit('closeShowDialog', false)"></div>
        </div>
        <div class="warn-line-box-bottom">
            <template v-if="sceneInfo && sceneInfo.obj === '视频测面积'">
                <div style="width: 210px">
                    <span>污染物</span>
                    <div style="width: 0; display: inline-block; margin-left: 10px">
                        <el-input v-model="pollutantValue" placeholder=""></el-input>
                    </div>
                </div>
                <div>
                    <span style="width: 42px; text-align: right; display: inline-block">面积</span>
                    <div style="width: 0; display: inline-block; margin-left: 10px">
                        <el-input
                            v-model="areaValue"
                            placeholder=""
                            @keyup.native="filterValueFn('污染物距离')"
                        ></el-input>
                    </div>
                </div>
                <div>
                    <span style="width: 42px; text-align: right; display: inline-block">位置</span>
                    <div style="width: 0; display: inline-block; margin-left: 10px">
                        <el-input v-model="locationValue" placeholder=""></el-input>
                    </div>
                </div>
            </template>
            <template v-if="sceneInfo && sceneInfo.obj === '拦截范围'">
                <div style="width: 250px">
                    <span>建议拦截时间</span>
                    <div style="width: 0; display: inline-block; margin-left: 10px">
                        <!-- <el-input
                            v-model="interceptTime"
                            placeholder=""
                            @keyup.native="filterValueFn('时间')"
                        ></el-input> -->
                        <el-date-picker
                            v-model="interceptTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            default-time="12:00:00"
                            popper-class="mydata"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div>
                    <span style="width: 84px; text-align: right; display: inline-block">污染物距离</span>
                    <div style="width: 0; display: inline-block; margin-left: 10px">
                        <el-input
                            v-model="pollutantDistance"
                            placeholder=""
                            @keyup.native="filterValueFn('污染物距离')"
                        ></el-input>
                    </div>
                </div>
                <div>
                    <span style="width: 84px; text-align: right; display: inline-block">位置</span>
                    <div style="width: 0; display: inline-block; margin-left: 10px">
                        <el-input v-model="locationValue" placeholder=""></el-input>
                    </div>
                </div>
            </template>
            <template v-if="sceneInfo && sceneInfo.obj === '视频测流速'">
                <div style="margin-bottom: 10px; width: 135px">
                    两点距离：{{ sceneInfo.json['2d'].distance.toFixed(1) }} m
                </div>
                <div>水流速度：{{ sceneInfo.json['2d'].speed.toFixed(1) }} m/s</div>
            </template>
            <div
                style="padding-left: 35px"
                v-if="
                    (sceneInfo && sceneInfo.obj === '视频测面积') ||
                    (sceneInfo && sceneInfo.obj === '拦截范围')
                "
            >
                <div style="display: table; margin: 0 auto">
                    <el-button class="btn" type="primary" @click="$emit('closeShowDialog', false)"
                        >取消</el-button
                    >
                    <el-button
                        class="btn btn-confirm"
                        type="primary"
                        @click="
                            editSceneInfo({
                                drawObj: sceneInfo.json['2d'].obj,
                                area: areaValue,
                                location: locationValue,
                                pollutant: pollutantValue,
                                interceptTime: interceptTime,
                                pollutantDistance: pollutantDistance,
                            })
                        "
                        >确认</el-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dialongStyle: Object,
        showDialog: Boolean,
        editSceneInfo: Function,
        sceneInfo: Object,
    },
    data() {
        return {
            pxNum: 0,
            pollutantValue: (this.sceneInfo && this.sceneInfo.json['2d'].pollutant) || '',
            areaValue: (this.sceneInfo && this.sceneInfo.json['2d'].area) || '',
            locationValue: (this.sceneInfo && this.sceneInfo.json['2d'].location) || '',
            interceptTime: (this.sceneInfo && this.sceneInfo.json['2d'].interceptTime) || '',
            pollutantDistance: (this.sceneInfo && this.sceneInfo.json['2d'].pollutantDistance) || '',
        };
    },
    computed: {
        isBlueColor() {
            return this.sceneInfo.obj === '拦截范围';
        },
    },
    methods: {
        filterValueFn(type) {
            if (type === '污染物距离') {
                this.pollutantDistance = this.pollutantDistance.replace(/[^0-9kmKM]/g, '');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input-number--small {
    position: relative;

    width: 74px;
    &::before {
        content: 'px';
        position: absolute;
        top: -1px;
        right: 30px;
        font-size: 12px;
    }
}
::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase {
    background: rgba(7, 17, 80, 0);
    color: #fff;
    border: 0px !important;
    line-height: 20px !important;
}
::v-deep .el-input-number.is-controls-right .el-input-number__increase {
    border: 0;
}

::v-deep .el-input-number.is-controls-right .el-input__inner {
    background: rgba(7, 17, 80, 0);
    padding-left: 10px;
    padding-right: 0;
    text-align: left;
    width: 100% !important;
    color: #fff;
    border: 1px solid #ffffff4d;
}
::v-deep .el-icon-arrow-up:before {
    content: '\e78f';
}
::v-deep .el-icon-arrow-down:before {
    content: '\e790';
}
::v-deep .el-input--small .el-input__inner {
    width: 160px;
    height: 24px;
    border-radius: 1px 1px 1px 1px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    margin-bottom: 10px;
    color: #fff;
}
::v-deep .el-input__inner {
    background: transparent;
    padding-left: 8px;
}
::v-deep .el-input__prefix {
    left: -1px;
    top: -4px;
}
::v-deep .el-input__suffix {
    right: 57px;
    top: -4px;
}
::v-deep .el-input--suffix .el-input__inner {
    padding-right: 0;
    padding-left: 20px;
}
.warn-line-box {
    position: absolute;
    left: 0;
    top: 0;
    // width: 243px;
    // height: 188px;
    background: linear-gradient(180deg, #853750ff 0%, #564669ff 100%);
    box-shadow: inset 0px 1px 12px 0px rgba(255, 13, 71, 0.65);
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #ff265b;
    font-size: 14px;
    color: #fff;
    .warn-line-box-top {
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
        border-bottom: 1px solid #ff265bff;

        .el-icon-close {
            cursor: pointer;
        }
    }
    .warn-line-box-bottom {
        padding: 10px 20px;
        .btn {
            width: 64px;
            line-height: 8px;
            background: rgba(255, 38, 91, 0.2);
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #ff265b;

            &.btn-confirm {
                margin-left: 12px;
                color: #fff;

                background: rgba(255, 38, 91, 0.7);
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #ff265b;
            }
        }
    }
    &::before {
        content: '';
        position: absolute;
        left: -10px;
        top: 10px;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 10px solid #ff265bff;
    }
}
.isBlueColor {
    background: rgba(7, 17, 80, 0.8);
    box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
    border: 1px solid #49f0fd;
    .warn-line-box-top {
        border-bottom: 1px solid #49f0fd;
    }
    .warn-line-box-bottom {
        .btn {
            background: rgba(73, 240, 253, 0.2);
            border: 1px solid #49f0fd;
            &.btn-confirm {
                color: #071150ff;
                background: #49f0fd;
                border: 1px solid #49f0fd;
            }
        }
    }
    &::before {
        border-right: 10px solid #49f0fd;
    }
}
</style>
